import { render, staticRenderFns } from "./identitySelection.vue?vue&type=template&id=5eef509e&scoped=true&"
import script from "./identitySelection.vue?vue&type=script&lang=js&"
export * from "./identitySelection.vue?vue&type=script&lang=js&"
import style0 from "./identitySelection.vue?vue&type=style&index=0&id=5eef509e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eef509e",
  null
  
)

export default component.exports